module.exports = __webpack_public_path__ + "static/media/quad1.b261b254.png";